import { formElement } from "../../forms/FormElement";
import HotWorkCategoryThreeOptionsFormState from "../../forms/Permits/EnergyHarbourPermit/HotWorkCategoryThreeOptionsFormState";

type HotWorkCategoryThreeOptions = {
    vacuumTruck: boolean;
    excavator: boolean;
    craneTruck: boolean;
    generator: boolean;
    boat: boolean;
    drone: boolean;
    openExClassifiedEquipment: boolean;
    multimeter: boolean;
    nonExCamera: boolean;
    GPS: boolean;
    other: string;
};

export default HotWorkCategoryThreeOptions;

export function HotWorkCategoryThreeOptions_toFormState(
    hotWorkCategoryThreeOptions: HotWorkCategoryThreeOptions
): HotWorkCategoryThreeOptionsFormState {
    return {
        boat: formElement(hotWorkCategoryThreeOptions.boat),
        craneTruck: formElement(hotWorkCategoryThreeOptions.craneTruck),
        drone: formElement(hotWorkCategoryThreeOptions.drone),
        excavator: formElement(hotWorkCategoryThreeOptions.excavator),
        generator: formElement(hotWorkCategoryThreeOptions.generator),
        GPS: formElement(hotWorkCategoryThreeOptions.GPS),
        multimeter: formElement(hotWorkCategoryThreeOptions.multimeter),
        nonExCamera: formElement(hotWorkCategoryThreeOptions.nonExCamera),
        openExClassifiedEquipment: formElement(hotWorkCategoryThreeOptions.openExClassifiedEquipment),
        other: formElement(hotWorkCategoryThreeOptions.other),
        vacuumTruck: formElement(hotWorkCategoryThreeOptions.vacuumTruck)
    };
}
